import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { useState } from 'react'
import DialogPageComponent from '../../components/DialogPageComponent'
import { SimpleButton } from '@unwrittenmedia/simple-components'

export const Route = createFileRoute('/watch/join')({
  component: JoinPlace,
})

function JoinPlace() {
  const [placeCode, setPlaceCode] = useState('')
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState('')
  const navigate = useNavigate()

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    setError('')
    
    if (!placeCode.trim()) {
      setError('Please enter a place code')
      return
    }

    setIsLoading(true)
    
    try {
      // TODO: Replace with actual API call to verify place code
      await new Promise(resolve => setTimeout(resolve, 1000))
      
      // TODO: Actual implementation would:
      // 1. Call API to verify place code is active
      // 2. Get the actual place ID from the response
      // 3. Redirect to /watch/ACTUAL_PLACE_ID
      
      navigate({ to: `/watch/${placeCode}` })
    } catch (err) {
      setError('Failed to verify place code. Please try again.')
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <DialogPageComponent>
      <h1 className="text-2xl font-bold mb-6">Join Place</h1>
      
      <form onSubmit={handleSubmit} className="space-y-4">
        <div>
          <label htmlFor="placeCode" className="block text-sm font-medium text-gray-700 dark:text-mist-300 mb-1">
            Place Code
          </label>
          <input
            type="text"
            id="placeCode"
            value={placeCode}
            onChange={(e) => setPlaceCode(e.target.value)}
            placeholder="Enter place code"
            className="w-full px-3 py-2 border border-gray-300 dark:border-mist-700 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            disabled={isLoading}
          />
        </div>

        {error && (
          <div className="text-red-600 text-sm bg-red-50 p-3 rounded-md">
            {error}
          </div>
        )}

        <SimpleButton
          type="submit"
          disabled={isLoading || !placeCode.trim()}
          className="w-full"
          color="info"
          size="md"
        >
          {isLoading ? 'Verifying...' : 'Join Place'}
        </SimpleButton>
      </form>

      <div className="mt-6 text-sm text-gray-600 dark:text-mist-400">
        <p>Enter the place code provided by your organizer to view live slides.</p>
      </div>
    </DialogPageComponent>
  )
}